import type { FC } from "react";
import { useDispatch } from "react-redux";

import { ActionButton, ActionButtonIntent, ActionButtonSize } from "widgets";

import { downloadJnlpFile } from "@/redux/modules/files.ts";
import type { IJnlpDownloadInputData } from "@/redux/modules/files.ts";
import type { ReduxDispatch } from "@/redux/redux-utils.ts";
import { ENTITY_TYPE, EXT_APP_MODULES } from "@/settings/settings.ts";
import type { IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

const JnlpFileCell: FC<IAgGridCellProps> = (props) => {
  const dispatch = useDispatch<ReduxDispatch>();

  if (!props.value || !props.data) {
    return null;
  }
  const { data } = props;
  const { id, groupType } = data;

  let moduleId: string = null;
  switch (groupType) {
    case ENTITY_TYPE.ANALYST_SESSION:
      moduleId = EXT_APP_MODULES.ANALYST.id;
      break;
    case ENTITY_TYPE.WORKFLOW_SESSION:
      moduleId = EXT_APP_MODULES.PROCESSOR.id;
      break;
    default:
      throw Error(`Unknown session type ${groupType}`);
  }

  const jnlpDownloadPayload: IJnlpDownloadInputData = {
    moduleId: moduleId,
    sessionId: id,
  };

  return (
    <TableCell>
      <ActionButton
        label={`Open Session in ${moduleId}`}
        {...props}
        icon={"open_in_new"}
        onPress={() => dispatch(downloadJnlpFile(jnlpDownloadPayload))}
        size={ActionButtonSize.Small}
        intent={ActionButtonIntent.Outlined}
      />
    </TableCell>
  );
};

export default JnlpFileCell;
